import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import HOC from '../../components/HOC/HOC';
import { SuccessfullyModal } from '../../components/Modals/Modals';
import addjob from '../../css/style.module.css';

const EditWallet = () => {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const handlemodal = () => {
    setShow(true);
    setTimeout(() => {
      setShow(false);
      navigate(-1);
    }, 2000);
  };

  return (
    <>
      <SuccessfullyModal
        show={show}
        handleClose={() => setShow(false)}
        text={'Successfully Updated'}
      />
      <div className={addjob.jobmanagementCotainer}>
        <div className={addjob.jobtoppart}>
          <div className={addjob.pagetitle}>
            <h6>Edit Wallet</h6>
          </div>
          <div className={addjob.rightbuttons}>
            <div className={addjob.rightbuttons2} onClick={() => navigate(-1)}>
              <p>Wallet List</p>
            </div>
          </div>
        </div>

        <div className={addjob.addjobcontainer}>
          <div className={addjob.addjobsubcontainer}>
            <div className={addjob.addjobtopic}>
              <h6>Wallet Details</h6>
            </div>
            <div className={addjob.addjobinputs}>
              <label htmlFor="">User Name*</label>
              <input type="text" placeholder="Suhas" />
            </div>
            <div className={addjob.addjobinputs}>
              <label htmlFor="">Wallet ID*</label>
              <input type="text" placeholder="Suhas" />
            </div>
          </div>
          <div className={addjob.addjobbutton}>
            <div className={addjob.rightbuttons}>
              <button onClick={() => navigate(-1)}>Cancel</button>
            </div>
            <div className={addjob.rightbuttons}>
              <button onClick={handlemodal} style={{ background: '#F05423' }}>
                Update
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HOC(EditWallet);
